import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';

import { throwError } from 'rxjs';
import { AppConfig } from 'src/assets/config/config/app-config';
// import { Category, CategoryNode, NewCategory } from '../_models';

@Injectable({ providedIn: 'root' })
export class VirtualFolderService {
    apiUrl: string
    allVFolders = [];
    constructor(private http: HttpClient,
        private config: AppConfig) {
        this.apiUrl = this.config.getConfig("apiUrl")
    }

    getTree(): Observable<any[]> {
        return this.http.get<any[]>(this.apiUrl + `/virtual-folder/tree`)
            .pipe()
    }

    getAllVirtualFolders(){
        return this.http.get<any[]>(this.apiUrl + `/virtual-folder/all`)
            .pipe()
    }

    async getFlattenedTree() {
        this.allVFolders = [];
        let folders = await this.http.get<any[]>(this.apiUrl + `/virtual-folder/tree`).toPromise()
        this.flattenVirtualFolder(folders);
        return  this.allVFolders
    }

    private flattenVirtualFolder(folders) {
        for (let i = 0; i < folders.length; i++) {
            let tempFolder = folders[i];
            if (tempFolder['sub_folders']) {
                this.flattenVirtualFolder(tempFolder['sub_folders'])

                if (!this.allVFolders.some(el => el.id === tempFolder['id'])) {
                    this.allVFolders.push(tempFolder);
                }
            } else {
                if (!this.allVFolders.some(el => el.id === tempFolder['id'])) {
                    this.allVFolders.push(tempFolder)
                }
            }
        }
    }

    get(folderId, offset): Observable<any> {
        return this.http.get<any>(this.apiUrl + `/virtual-folder/` + folderId+`?offset=`+offset+`&limit=200`)
            .pipe(
            );
    }

    getFolderDetails(folderId): Observable<any> {
        return this.http.get<any>(this.apiUrl + `/virtual-folder/meta-data/` + folderId)
            .pipe(
            );
    }

    getApplicationData(req: any, offset: number): Observable<any> {
        //var response: new HttpResponse()
        //console.log("Req: " + JSON.stringify(req));
        return this.http.post<any>(this.apiUrl + `/virtual-folder/applicant-data?limit=100&offset=` + offset, req)
            .pipe();

    }

    createFolder(req: any): Observable<any> {
        return this.http.post(this.apiUrl + `/virtual-folder/create`, req).pipe(map(obj => obj),
            (catchError(this.errorHandler))

        )
    }

    deleteFolder(id) {
        return this.http.delete<any>(this.apiUrl + `/virtual-folder/delete?id=` + id)
        .pipe()
    }

    updateFolder(req: any): Observable<any> {
        return this.http.put(this.apiUrl + `/virtual-folder/update`, req).pipe(map(obj => obj),
            (catchError(this.errorHandler))

        )
    }

    errorHandler(error: HttpErrorResponse) {
        return throwError(error);
    }
}

